var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.pageLoading || _vm.loading}},[(_vm.show)?_c('iframe',_vm._b({attrs:{"height":_vm.height}},'iframe',_vm.iframeProps,false)):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }